import {AbstractControl, FormGroup} from '@angular/forms';
import validateRfc from 'validate-rfc';

export function emailFormat(control: AbstractControl): any {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
    if (control && (control.value !== null || control.value !== undefined)) {
        if (!regex.test(control.value) && control.value !== '') {
            return {
                emailFormat: true,
            };
        } else {
            return null;
        }
    }
}

export function passEquals(control: FormGroup): any {
    if (control && (control.get('passNew').value !== null || control.get('passNew').value !== undefined)
        && (control.get('passRepit').value !== null || control.get('passRepit').value !== undefined)) {
        if (control.get('passNew').value !== control.get('passRepit').value
            && control.get('passNew').value !== '' && control.get('passRepit').value !== '') {
            return {
                passEquals: true,
            };
        } else {
            return null;
        }
    }
}

export function passFormat(control: AbstractControl): any {
    const regex = /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{13,}$/;
    if (control && (control.value !== null || control.value !== undefined)) {
        if (!regex.test(control.value) && control.value !== '') {
            return {
                passFormat: true,
            };
        } else {
            return null;
        }
    }
}

export function expirationDate(control: AbstractControl): any {
    const regex = /^[0-9]{2}\/[0-9]{2}$/;
    if (control && (control.value !== null || control.value !== undefined)) {
        if (!regex.test(control.value) && control.value !== '') {
            return {
                expirationDate: true,
            };
        } else {
            const year = new Date().getFullYear().toString().substring(2, 4);
            const month = new Date().getMonth();
            const splitData = control.value.split('/');
            if (splitData[0] > 0 && splitData[0] <= 12 && splitData[1] > year
                || splitData[1] === year && splitData[0] >= (month + 1) && splitData[0] <= 12) {
                return null;
            }
            return {
                expirationDate: true,
            };
        }
    }
}

export function rfcFormat(control: AbstractControl): any {
    if (control && (control.value !== null || control.value !== undefined)) {
        if (!validateRfc(control.value).isValid && control.value !== '') {
            return {
                rfcFormat: true
            };
        } else {
            return null;
        }
    }
}
export function cpFormart( control:AbstractControl):any{
    const regex = /^[0-9]{5}$/;
    if(regex.test(control.value))
    {
        return{
            cpFormart:true
        };
    }else{
        return null;
    }
}